import { FunctionalComponent } from 'preact';
import cn from 'classnames';

import { getLinkedTabs } from '../../slice/thunks/api';
import styles from './styles.module.scss';
import { useEffect, useState } from 'preact/hooks';

const LinkedTabs: FunctionalComponent = () => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      const data = await getLinkedTabs();
      setLinks(data);
    };

    fetchLinks();
  }, []);

  const handleLinkClick = (link) => (event) => {
    event.preventDefault();

    // setTimeout(() => {
    window.location.href = link.link;
    // }, 200);
  };

  if (links.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {links.map((link) => (
        <a
          key={link.link}
          href={link.link}
          className={cn(styles.element)}
          rel="noopener noreferrer"
          onClick={handleLinkClick(link)}
        >
          <img
            className={styles.favicon}
            src={link.image}
            alt={link.title}
            height={16}
            width={16}
          />
          {link.title}
        </a>
      ))}
    </div>
  );
};

export default LinkedTabs;
